// Profile Analytics docs: https://gotinder.atlassian.net/wiki/x/z_ypAQ
// event name
import { MEDIA_TYPE_PHOTO, MEDIA_TYPE_SHORT_VIDEO, MEDIA_TYPE_VIDEO } from 'Store/media/constants';

import {
  APP_SOURCE_DEEPLINK,
  APP_SOURCE_EDIT_PROFILE,
  APP_SOURCE_HOME_PROFILE_TAB,
  APP_SOURCE_ONBOARDING,
} from 'Store/sparks/constants/appSource';

export const PROFILE_ADD_PHOTO = 'Profile.AddPhoto';
export const PROFILE_DELETE_PHOTO = 'Profile.DeletePhoto';
export const PROFILE_CHANGE_PHOTO_ORDER = 'Profile.ChangePhotoOrder';

export const PROFILE_EDIT = 'Profile.Edit';
export const PROFILE_EDIT_SCHOOL = 'Profile.EditSchool';

export const USER = 'User';
export const PROFILE_INTERACT = 'Profile.Interact';
export const SETTINGS_INTERACT = 'Settings.Interact';
export const EDIT_PROFILE_INTERACT = 'EditProfile.Interact'; // track events pertaining to edit profile
export const USER_INTERACTION_EDIT_PROFILE = 'UserInteraction.EditProfile'; // track opening the edit profile screen
export const USER_INTERACTION_SETTINGS_PHONE = 'UserInteraction.Settings.Phone';
export const USER_INTERACTION_SETTINGS_EMAIL = 'UserInteraction.Settings.Email';

// Content Creation Analytics spec: https://gotinder.atlassian.net/wiki/x/0Z-XAQ
// attribute
export const MEDIA_FROM_FACEBOOK = 0;
export const MEDIA_FROM_CAMERA_ROLL = 1;
export const MEDIA_FROM_INSTAGRAM = 2;
export const MEDIA_FROM_CAMERA = 3;
export const MEDIA_FROM_PROMPT = 5;

export const MEDIA_FROM_NAMES = {
  [MEDIA_FROM_CAMERA_ROLL]: 'Camera Roll',
  [MEDIA_FROM_CAMERA]: 'Camera',
  [MEDIA_FROM_FACEBOOK]: 'Facebook',
  [MEDIA_FROM_INSTAGRAM]: 'Instagram',
  [MEDIA_FROM_PROMPT]: 'Prompt',
};

export const MEDIA_TYPE_VALUES = {
  [MEDIA_TYPE_PHOTO]: 0,
  [MEDIA_TYPE_VIDEO]: 1,
  [MEDIA_TYPE_SHORT_VIDEO]: 4,
};

export const TEMPLATE_TYPE_TEXT_PHOTO = 2;

export const SOURCE_FROM_NAMES = {
  [APP_SOURCE_EDIT_PROFILE]: 0,
  [APP_SOURCE_HOME_PROFILE_TAB]: 1,
  [APP_SOURCE_ONBOARDING]: 2,
  [APP_SOURCE_DEEPLINK]: 3,
};

export const PROFILE_ELEMENT_MEDIA = 'media';
export const PROFILE_ELEMENT_TYPES_VIDEO = 'video';

export const PROFILE_ACTION_PLAY = 'play';
export const PROFILE_ACTION_MUTE = 'mute';
export const PROFILE_ACTION_UNMUTE = 'unmute';

export const VIEW_PERMISSION_PUBLIC = 'public';

export const MEDIA_INTERACT = 'Media.Interact';

export const MEDIA_ACTION_SELECT = 'select';
export const MEDIA_ACTION_TAP = 'tap';
export const MEDIA_ACTION_UPLOAD = 'upload';
export const MEDIA_ACTION_SWIPE = 'swipe';

export const MEDIA_ACTION_VALUE_ADD_MEDIA = 'add_media';
export const MEDIA_ACTION_VALUE_MEDIA_SUBMIT = 'media_submit';
export const MEDIA_ACTION_VALUE_NAVIGATION_CANCEL = 'navigation_cancel';
export const MEDIA_ACTION_VALUE_NAVIGATION_DONE = 'navigation_done';
export const MEDIA_ACTION_VALUE_NAVIGATION_NEXT = 'navigation_next';
export const MEDIA_ACTION_VALUE_PREVIEW = 'preview';
export const MEDIA_ACTION_VALUE_REPLACE_MEDIA = 'replace_media';
export const MEDIA_ACTION_VALUE_SECTION_BUTTON = 'section_button';

export const MEDIA_ACTION_TYPE_CHANGE_PREVIEWS = 'change_previews';
export const MEDIA_ACTION_TYPE_EDIT_MEDIA = 'edit_media';
export const MEDIA_ACTION_TYPE_OPEN_GALLERY = 'open_gallery';
export const MEDIA_ACTION_TYPE_OPEN_MEDIA = 'open_media';
export const MEDIA_ACTION_TYPE_RETURN = 'return';
export const MEDIA_ACTION_TYPE_SAVE_MEDIA = 'save_media';
export const MEDIA_ACTION_TYPE_SELECT_PHOTO = 'select_photo';
export const MEDIA_ACTION_TYPE_SELECT_PROMPT = 'select_prompt';

export const MEDIA_ACTION_SOURCE_MEDIA_EDIT_PHOTOS = 'media_edit_photos';

export const MEDIA_ACTION_RESULT_SOURCE_SELECTOR = 'source_selector';
export const MEDIA_ACTION_RESULT_SYSTEM_GALLERY = 'system_gallery';

export const ACTION_SOURCE_ADD_MEDIA = 'add_media';
export const ACTION_SOURCE_SUBMIT = 'submit';
export const ACTION_SOURCE_SYSTEM_GALLERY = 'system_gallery';
